import { cn } from "../../../utils/cn";

type DividerProps = {
  className?: string;
};

export const Divider = ({ className }: DividerProps) => {
  return <div className={cn("tw-h-[1px] tw-w-full tw-bg-border", className)} />;
};
